import { Injectable, Injector } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { ToasterUtilService } from '../util/toaster-util.service';
import { SessaoUtil } from '../util/sessao-util';
import { GenericService } from './generic.service';
import { EmpresaModel } from '../util/model/empresa.model';
import { Router } from '@angular/router';
import { UtilService } from '../util/util.service';
import { AlertaMensagemModel } from '../util/model/alerta-mensagem.model';


@Injectable()
export class EmpresaService extends GenericService<EmpresaModel> {

  constructor (
    protected http: Http,
    protected sessaoUtil: SessaoUtil,
    protected toasterUtil: ToasterUtilService,
    protected router: Router,
    protected injector: Injector,
  ) {
      super(http, sessaoUtil, toasterUtil, router, injector, '/empresas');
  }

  atualizaAtivo(id: number, value: boolean): Promise<boolean> {
    return this.http.post(
      this.getUrl() + '/atualizaAtivo/' + id + '/' + value,
      null,
      { headers: this.getHeaders() }
    )
    .toPromise()
    .then((response: Response)  => {
      this.handleMessage(response.headers);
      return response.json();
    }).catch(error => {
      this.handleErrorRetornoValidacao(error);
      return Promise.reject(error); // Re-lançar a exceção
    });
  }
  
  excluiBackups(id: number): Promise<AlertaMensagemModel> {
    return this.http.post(
      this.getUrl() + '/limpaBackups/' + id,
      null,
      { headers: this.getHeaders() }
    )
    .toPromise()
    .then((response: Response) => {
      this.handleMessage(response.headers);
      return response.json().mensagens[0];
    }).catch(this.handleErrorRetornoValidacao.bind(this));
  }

  retornaEmpresas(isAdmin: boolean, idUsuario: number){
    if(isAdmin) {
      return this.http.get(this.getUrl(),  { headers: this.getHeaders()})
        .toPromise()
        .then((response: Response) => {
            this.handleMessage(response.headers);
            return response.json();
        })
        .catch(this.handleError);
    }

    return this.http.post(
      UtilService.getUrl()+ '/usuarios/listaEmpresasUsuario',
      idUsuario,
      { headers: this.getHeaders() }
    )
    .toPromise()
    .then((response: Response) => {
      this.handleMessage(response.headers);
      return response.json();
    }).catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/empresa.service.ts